/* eslint-disable */
export default {
  unknown: 'Onbekend',
  multipleMatches: 'Meerdere overeenkomsten',
  anonymous: 'Anoniem',
  none: 'Geen',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"multipleMatches"@#@ @source: @#@"Multiple matches"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"none"@#@ @source: @#@"None"@#@
